import { useEffect } from "react";
import PaymentDrawTonightInterfaceStore from "../../interface/PaymentDrawTonightInterface";
import { useBreakpoint } from "../../../../../../../Common/utils/common";

const useBreakpointSync = () => {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "mobile";

  useEffect(() => {
    const { setIsMobile } = PaymentDrawTonightInterfaceStore.getState();
    setIsMobile(isMobile);
  }, [isMobile]);
};

export default useBreakpointSync;
